module.exports = __webpack_public_path__ + "img/background-technology-desktop.cf210dfe.jpg";